import { css } from "@emotion/react";
import React from "react";

export const fontFaceStyles = css`
  @import url("https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Angkor&family=Barlow+Condensed:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Barlow+Semi+Condensed:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Fredoka:wght@300..700&family=Heebo:wght@100..900&family=Merriweather:ital,opsz,wght@0,18..144,300..900;1,18..144,300..900&family=Playfair+Display:ital,wght@0,400..900;1,400..900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&family=Roboto:ital,wght@0,100..900;1,100..900&display=swap");
  @import url("https://p.typekit.net/p.css?s=1&k=wpu3jlw&ht=tk&f=48750.48732.48733.48734.48735.48736.48737.48738.48739.48740.48741.48742.48743.48744.48745.48746.48747.48748.48749&a=88334855&app=typekit&e=css");

  @font-face {
    font-family: "Merriweather fallback";
    size-adjust: 106%;

    src: local("Times New Roman");
  }

  @font-face {
    font-family: "Roboto Condensed fallback";
    size-adjust: 89%;

    src: local("Arial");
  }

  @font-face {
    font-family: "Roboto fallback";
    src: local("Arial");
  }

  @font-face {
    font-weight: 500;
    font-family: "San Francisco text";
    src: url("https://applesocial.s3.amazonaws.com/assets/styles/fonts/sanfrancisco/sanfranciscotext-regular-webfont.woff");
  }

  /* Bodoni Moda - Manually added the 18pt version of Bodoni Moda because that version not available in Google Fonts */
  @font-face {
    font-family: "Bodoni Moda";
    font-style: normal;
    font-display: swap;

    src: url("https://assets.i-scmp.com/fonts/bodoni-moda-18pt-regular.woff2") format("woff2");
    unicode-range:
      U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329,
      U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }

  @font-face {
    font-family: "Indivisible Variable";
    font-style: normal;
    font-stretch: normal;
    src:
      url("https://use.typekit.net/af/8a4c14/0000000000000000774bed0e/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3")
        format("woff2"),
      url("https://use.typekit.net/af/8a4c14/0000000000000000774bed0e/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3")
        format("woff"),
      url("https://use.typekit.net/af/8a4c14/0000000000000000774bed0e/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3")
        format("opentype");
    font-display: swap;
  }

  @font-face {
    font-weight: normal;
    font-family: "scmp-weather-icons";
    font-style: normal;
    src:
      url(https://assets.i-scmp.com/weather/fonts/scmp-weather-icons.eot?#iefix)
        format("embedded-opentype"),
      url(https://assets.i-scmp.com/weather/fonts/scmp-weather-icons.woff) format("woff"),
      url(https://assets.i-scmp.com/weather/fonts/scmp-weather-icons.woff2) format("woff2"),
      url(https://assets.i-scmp.com/weather/fonts/scmp-weather-icons.ttf) format("truetype"),
      url(https://assets.i-scmp.com/weather/fonts/scmp-weather-icons.svg#scmp-weather-icons)
        format("svg");
    font-display: block;
  }

  @font-face {
    font-weight: 500;
    font-family: "Mixta Sharp";
    font-style: normal;
    font-stretch: normal;
    src:
      url("https://use.typekit.net/af/02a393/00000000000000007735f3fc/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3")
        format("woff2"),
      url("https://use.typekit.net/af/02a393/00000000000000007735f3fc/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3")
        format("woff"),
      url("https://use.typekit.net/af/02a393/00000000000000007735f3fc/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3")
        format("opentype");
    font-display: swap;
  }

  @font-face {
    font-weight: 600;
    font-family: "Mixta Pro";
    font-style: italic;
    font-stretch: normal;
    src:
      url("https://use.typekit.net/af/8e39b4/00000000000000007735f3f5/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i6&v=3")
        format("woff2"),
      url("https://use.typekit.net/af/8e39b4/00000000000000007735f3f5/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i6&v=3")
        format("woff"),
      url("https://use.typekit.net/af/8e39b4/00000000000000007735f3f5/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i6&v=3")
        format("opentype");
    font-display: swap;
  }

  @font-face {
    font-weight: 800;
    font-family: "Mixta Pro";
    font-style: italic;
    font-stretch: normal;
    src:
      url("https://use.typekit.net/af/8e39b4/00000000000000007735f3f5/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i6&v=3")
        format("woff2"),
      url("https://use.typekit.net/af/21c6c5/00000000000000007735f3f6/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i8&v=3")
        format("woff"),
      url("https://use.typekit.net/af/21c6c5/00000000000000007735f3f6/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i8&v=3")
        format("opentype");
    font-display: swap;
  }

  @font-face {
    font-weight: 800;
    font-family: "Mixta Pro";
    font-style: normal;
    font-stretch: normal;
    src:
      url("https://use.typekit.net/af/02a517/00000000000000007735f407/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n8&v=3")
        format("woff2"),
      url("https://use.typekit.net/af/02a517/00000000000000007735f407/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n8&v=3")
        format("woff"),
      url("https://use.typekit.net/af/02a517/00000000000000007735f407/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n8&v=3")
        format("opentype");
    font-display: swap;
  }

  @font-face {
    font-weight: 500;
    font-family: "Mixta Pro";
    font-style: italic;
    font-stretch: normal;
    src:
      url("https://use.typekit.net/af/3f6695/00000000000000007735f402/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3")
        format("woff2"),
      url("https://use.typekit.net/af/3f6695/00000000000000007735f402/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3")
        format("woff"),
      url("https://use.typekit.net/af/3f6695/00000000000000007735f402/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3")
        format("opentype");
    font-display: swap;
  }

  @font-face {
    font-weight: 400;
    font-family: "Mixta Pro";
    font-style: italic;
    font-stretch: normal;
    src:
      url("https://use.typekit.net/af/53be55/00000000000000007735f405/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3")
        format("woff2"),
      url("https://use.typekit.net/af/53be55/00000000000000007735f405/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3")
        format("woff"),
      url("https://use.typekit.net/af/53be55/00000000000000007735f405/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3")
        format("opentype");
    font-display: swap;
  }

  @font-face {
    font-weight: 700;
    font-family: "Mixta Pro";
    font-style: italic;
    font-stretch: normal;
    src:
      url("https://use.typekit.net/af/2b242c/00000000000000007735f409/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3")
        format("woff2"),
      url("https://use.typekit.net/af/2b242c/00000000000000007735f409/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3")
        format("woff"),
      url("https://use.typekit.net/af/2b242c/00000000000000007735f409/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3")
        format("opentype");
    font-display: swap;
  }

  @font-face {
    font-weight: 200;
    font-family: "Mixta Pro";
    font-style: italic;
    font-stretch: normal;
    src:
      url("https://use.typekit.net/af/196682/00000000000000007735f40d/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i2&v=3")
        format("woff2"),
      url("https://use.typekit.net/af/196682/00000000000000007735f40d/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i2&v=3")
        format("woff"),
      url("https://use.typekit.net/af/196682/00000000000000007735f40d/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i2&v=3")
        format("opentype");
    font-display: swap;
  }

  @font-face {
    font-weight: 600;
    font-family: "Mixta Pro";
    font-style: normal;
    font-stretch: normal;
    src:
      url("https://use.typekit.net/af/09e685/00000000000000007735f411/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3")
        format("woff2"),
      url("https://use.typekit.net/af/09e685/00000000000000007735f411/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3")
        format("woff"),
      url("https://use.typekit.net/af/09e685/00000000000000007735f411/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3")
        format("opentype");
    font-display: swap;
  }

  @font-face {
    font-weight: 100;
    font-family: "Mixta Pro";
    font-style: normal;
    font-stretch: normal;
    src:
      url("https://use.typekit.net/af/456d60/00000000000000007735f412/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n1&v=3")
        format("woff2"),
      url("https://use.typekit.net/af/456d60/00000000000000007735f412/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n1&v=3")
        format("woff"),
      url("https://use.typekit.net/af/456d60/00000000000000007735f412/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n1&v=3")
        format("opentype");
    font-display: swap;
  }

  @font-face {
    font-weight: 500;
    font-family: "Mixta Pro";
    font-style: normal;
    font-stretch: normal;
    src:
      url("https://use.typekit.net/af/51d03b/00000000000000007735f413/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3")
        format("woff2"),
      url("https://use.typekit.net/af/51d03b/00000000000000007735f413/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3")
        format("woff"),
      url("https://use.typekit.net/af/51d03b/00000000000000007735f413/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3")
        format("opentype");
    font-display: swap;
  }

  @font-face {
    font-weight: 700;
    font-family: "Mixta Pro";
    font-style: normal;
    font-stretch: normal;
    src:
      url("https://use.typekit.net/af/9508be/00000000000000007735f414/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3")
        format("woff2"),
      url("https://use.typekit.net/af/9508be/00000000000000007735f414/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3")
        format("woff"),
      url("https://use.typekit.net/af/9508be/00000000000000007735f414/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3")
        format("opentype");
    font-display: swap;
  }

  @font-face {
    font-weight: 100;
    font-family: "Mixta Pro";
    font-style: italic;
    font-stretch: normal;
    src:
      url("https://use.typekit.net/af/cb047a/00000000000000007735f416/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i1&v=3")
        format("woff2"),
      url("https://use.typekit.net/af/cb047a/00000000000000007735f416/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i1&v=3")
        format("woff"),
      url("https://use.typekit.net/af/cb047a/00000000000000007735f416/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i1&v=3")
        format("opentype");
    font-display: swap;
  }

  @font-face {
    font-weight: 300;
    font-family: "Mixta Pro";
    font-style: normal;
    font-stretch: normal;
    src:
      url("https://use.typekit.net/af/b1a83b/00000000000000007735f417/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3")
        format("woff2"),
      url("https://use.typekit.net/af/b1a83b/00000000000000007735f417/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3")
        format("woff"),
      url("https://use.typekit.net/af/b1a83b/00000000000000007735f417/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3")
        format("opentype");
    font-display: swap;
  }

  @font-face {
    font-weight: 300;
    font-family: "Mixta Pro";
    font-style: italic;
    font-stretch: normal;
    src:
      url("https://use.typekit.net/af/334746/00000000000000007735f420/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3")
        format("woff2"),
      url("https://use.typekit.net/af/334746/00000000000000007735f420/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3")
        format("woff"),
      url("https://use.typekit.net/af/334746/00000000000000007735f420/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3")
        format("opentype");
    font-display: swap;
  }

  @font-face {
    font-weight: 900;
    font-family: "Mixta Pro";
    font-style: normal;
    font-stretch: normal;
    src:
      url("https://use.typekit.net/af/8b17f9/00000000000000007735f422/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3")
        format("woff2"),
      url("https://use.typekit.net/af/8b17f9/00000000000000007735f422/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3")
        format("woff"),
      url("https://use.typekit.net/af/8b17f9/00000000000000007735f422/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3")
        format("opentype");
    font-display: swap;
  }

  @font-face {
    font-weight: 900;
    font-family: "Mixta Pro";
    font-style: italic;
    font-stretch: normal;
    src:
      url("https://use.typekit.net/af/b17d49/00000000000000007735f427/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3")
        format("woff2"),
      url("https://use.typekit.net/af/b17d49/00000000000000007735f427/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3")
        format("woff"),
      url("https://use.typekit.net/af/b17d49/00000000000000007735f427/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3")
        format("opentype");
    font-display: swap;
  }

  @font-face {
    font-weight: 200;
    font-family: "Mixta Pro";
    font-style: normal;
    font-stretch: normal;
    src:
      url("https://use.typekit.net/af/ecfaa8/00000000000000007735f428/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n2&v=3")
        format("woff2"),
      url("https://use.typekit.net/af/ecfaa8/00000000000000007735f428/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n2&v=3")
        format("woff"),
      url("https://use.typekit.net/af/ecfaa8/00000000000000007735f428/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n2&v=3")
        format("opentype");
    font-display: swap;
  }

  @font-face {
    font-weight: 400;
    font-family: "Mixta Pro";
    font-style: normal;
    font-stretch: normal;
    src:
      url("https://use.typekit.net/af/f647f5/00000000000000007735f42a/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3")
        format("woff2"),
      url("https://use.typekit.net/af/f647f5/00000000000000007735f42a/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3")
        format("woff"),
      url("https://use.typekit.net/af/f647f5/00000000000000007735f42a/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3")
        format("opentype");
    font-display: swap;
  }
`;

/**
 * Workaround for layout shift with critical CSS
 * @link https://github.com/emotion-js/emotion/issues/2154#issuecomment-737482603
 */
export const FontFaceWorkaround = () => (
  <style
    dangerouslySetInnerHTML={{
      // The reason of importing the Roboto font is scmp-menu-component used Roboto font.
      __html: fontFaceStyles.styles,
    }}
  />
);
